import React, { useCallback, useEffect, useRef, useState } from 'react';
import { GoogleMap, useLoadScript, MarkerF, InfoWindowF } from '@react-google-maps/api';
import { Divider, Modal } from 'antd';
import MyButton from './Button';
import Typography from './Typography';
import { COLORS } from '../constants/Colors';
import CustomerAddressForm from './CustomerAddressForm';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import getSearchLocation from '../controllers/customer/CustomerApi';
import _, { debounce } from 'lodash';
import GetProfile from './VariableStore';
import { instance } from './AxiosClient';
import { v4 as uuidv4 } from 'uuid';
import { errorNotification, successNotification } from './Notification';
import { FormattedMessage, useIntl } from 'react-intl';
import { store } from '../utils/redux/store';

const CustomerAddressModal = (props) => {
  const {
    isOpen,
    onCancle,
    isEdit,
    isSaveAddr,
    customerData,
    form,
    addressEditData,
    selectArea,
    setSelectArea,
    setEventAddress,
    setIsOpenAddrModal,
    tempDataAdd,
    setTempDataAdd,
    setIsTemp,
    isTemp,
    setIsSelect,
    isSelect,
    setAddressArea,
    addressArea
  } = props;
  const isDesktop = useIsDesktop();
  const [isShowMap, setIsShowMap] = useState(false);
  const [center, setCenter] = useState('');
  const [position, setPosition] = useState('');
  const [loading, setLoading] = useState(false);
  const [visibleInfoWindow, setVisibleInfoWindow] = useState(false);
  const [dragMarker, setDragMarker] = useState('');
  const intl = useIntl();
  const [map, setMap] = useState(null);
  const [options, setOptions] = useState([]);
  const [selectAddress, setSelectAddress] = useState();
  const mapRef = useRef();
  const states = store.getState();

  const handleSearchLocation = async (fieldChang) => {
    setIsSelect(true)
    // //console.log('options', fieldChang);
    const filterData = _.filter(options, (item) => { return item.addressName === fieldChang })
    if (_.size(filterData) === 0) {
      errorNotification(intl.formatMessage({ id: 'saveErrorNotification', defaultMessage: 'Failed' }));
    } else {
      setAddressArea(_.get(filterData, '[0]'));
    }

    setLoading(false);
  };



  const handleCancle = () => {
    setIsShowMap(false);
    setSelectArea(false);
    setVisibleInfoWindow(true);
    form.resetFields();
    onCancle();
  };

  const handleClickSave = async () => {
    if (isShowMap) {
      const customerId = GetProfile('customerId');
      const customerName = GetProfile('customerName');
      const comCode = GetProfile('customerCode');
      const customerAddressBookId = _.get(addressEditData, 'customerAddressBookId');
      const body = {
        customerId: customerId,
        addressName: customerData.customerContactName + '·' + _.get(selectAddress, 'addressName'),
        customerName: customerName,
        contactId: customerData.customerContactId,
        contactName: customerData.customerContactName,
        address: _.get(selectAddress, 'addressRaw'),
        address2: _.get(selectAddress, 'address2'),
        fullAddress: _.get(selectAddress, 'address'),
        subDistrict: _.get(selectAddress, 'subDistrict'),
        district: _.get(selectAddress, 'district'),
        province: _.get(selectAddress, 'province'),
        postCode: _.get(selectAddress, 'postCode'),
        lat: _.get(selectAddress, 'lat'),
        lng: _.get(selectAddress, 'lng'),
        description: undefined,
      };
      // if (isTemp === false) {
      //   const newData = [...tempDataAdd, body];
      //   setTempDataAdd(newData);

      //   form.resetFields();
      //   setIsShowMap(false);
      //   setEventAddress((current) => !current);
      //   successNotification(intl.formatMessage({ id: 'saveSuccessNotification', defaultMessage: 'Success' }));
      //   setIsOpenAddrModal(false);
      //   setIsTemp(true);
      //   onCancle();
      // } else {
      try {
        const response = isEdit
          ? await instance.put(`/v3/business-partner/manager/company/${comCode}/customer-address-books/${customerAddressBookId}`, body)
          : await instance.post(`/v3/business-partner/manager/company/${comCode}/customer-address-books`, body);
        form.resetFields();
        setIsShowMap(false);
        setEventAddress((current) => !current);
        successNotification(intl.formatMessage({ id: 'saveSuccessNotification', defaultMessage: 'Success' }));
        setIsOpenAddrModal(false);
        onCancle();
      } catch (error) {
        // //console.log('error Failed:', error);
        errorNotification(intl.formatMessage({ id: 'saveErrorNotification', defaultMessage: 'Failed' }));
      }
      // }
    } else {
      form
        .validateFields()
        .then(async (values) => {
          setLoading(true);
          const uuid = uuidv4();
          let newData = await getSearchLocation({
            name: form.getFieldValue('address') + ' ' + _.get(addressArea, 'addressName'),
          });
          if (_.size(newData) > 0) {
            setSelectAddress({
              addressName: form.getFieldValue('addressname'), //Address Name
              addressRaw: form.getFieldValue('address') + ' ' + _.get(addressArea, 'addressName'), //Address From AutoComplete
              address: _.get(newData, '[0].address'), // Full Address from Google API 
              address2: form.getFieldValue('address'),
              lat: _.get(newData, '[0].lat'),
              lng: _.get(newData, '[0].lng'),
              name: _.get(newData, '[0].name'),
              addressBookId: uuid,
              status: 'normal_address',
              subDistrict: _.get(addressArea, 'subDistrictName'),
              district: _.get(addressArea, 'districtName'),
              province: _.get(addressArea, 'provinceName'),
              postCode: _.get(addressArea, 'zipCode'),
            });
            setCenter({
              lat: parseFloat(_.get(newData, '[0].lat')),
              lng: parseFloat(_.get(newData, '[0].lng')),
            });
            setPosition({
              lat: parseFloat(_.get(newData, '[0].lat')),
              lng: parseFloat(_.get(newData, '[0].lng')),
            });
            setVisibleInfoWindow(true);
            setLoading(false);
            setIsShowMap(true);
          } else {
            let noLocation = await getSearchLocation({
              name: _.get(addressArea, 'addressName'),
            });
            if (_.size(noLocation) > 0) {
              setSelectAddress({
                addressName: form.getFieldValue('addressname'), //Address Name
                addressRaw: form.getFieldValue('address') + ' ' + _.get(addressArea, 'addressName'), //Address From AutoComplete
                address: _.get(noLocation, '[0].address'), // Full Address from Google API 
                address2: form.getFieldValue('address'),
                lat: _.get(noLocation, '[0].lat'),
                lng: _.get(noLocation, '[0].lng'),
                name: _.get(noLocation, '[0].name'),
                addressBookId: uuid,
                status: 'normal_address',
                subDistrict: _.get(addressArea, 'subDistrictName'),
                district: _.get(addressArea, 'districtName'),
                province: _.get(addressArea, 'provinceName'),
                postCode: _.get(addressArea, 'zipCode'),
              });
              setCenter({
                lat: parseFloat(_.get(noLocation, '[0].lat')),
                lng: parseFloat(_.get(noLocation, '[0].lng')),
              });
              setPosition({
                lat: parseFloat(_.get(noLocation, '[0].lat')),
                lng: parseFloat(_.get(noLocation, '[0].lng')),
              });
              setVisibleInfoWindow(true);
              setLoading(false);
              setIsShowMap(true);
            } else {
              errorNotification(intl.formatMessage({ id: 'saveErrorNotification', defaultMessage: 'Failed' }));
            }
          }
        })
        .catch((info) => {
          // //console.log('Validate Failed:', info);
        });
    }
  };

  const libraries = ['places'];
  const mapContainerStyle = {
    height: isDesktop ? `400px` : 'calc(100vh - 400px)',
    width: '100%',
    position: 'relative',
  };

  const defaultMapOption = {
    fullscreenControl: false,
    fullscreenControlOptions: false,
    streetViewControl: false,
    clickableIcons: false,
    zoomControl: false,
    gestureHandling: 'cooperative',
    mapTypeControl: true,
  };


  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: states.mapKeyReducer,
    libraries,
  });

  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);

  if (loadError) return 'Error loading maps';
  if (!isLoaded) return 'Loading Maps';

  // //console.log("selectAddress", selectAddress)

  const onDragEnd = async (evt) => {
    let area = await getSearchLocation({ location: evt.latLng });
    const uuid = uuidv4();
    const array = _.split(area.address, ',');
    const slicedString = _.initial(array).join(',');
    setSelectAddress({
      addressName: _.get(selectAddress, 'addressName'), //Address Name
      addressRaw: _.get(selectAddress, 'addressRaw'), //Address From AutoComplete
      address: slicedString, // Dragable New Data
      address2: _.get(selectAddress, 'address2'),
      lat: area.lat,
      lng: area.lng,
      name: area.name,
      addressBookId: uuid,
      status: 'normal_address',
    });

    setCenter({
      lat: parseFloat(_.get(area, 'lat')),
      lng: parseFloat(_.get(area, 'lng')),
    });
    setPosition({
      lat: parseFloat(_.get(area, 'lat')),
      lng: parseFloat(_.get(area, 'lng')),
    });
    setDragMarker(uuid);
    // form.setFieldsValue({
    //   fulladdress: slicedString,
    // });
  };

  const onClickMarker = (id) => {
    setVisibleInfoWindow(true);
  };

  const onCloseMarker = () => {
    setVisibleInfoWindow(false);
  };

  const checkView =
    isShowMap && isDesktop
      ? [
        <MyButton
          onClick={handleCancle}
          style={{
            width: isDesktop ? '25%' : '30%',
          }}
        >
          <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
        </MyButton>,
        <MyButton
          onClick={() => {
            setIsShowMap(false);
          }}
          style={{
            width: isDesktop ? '25%' : '30%',
          }}
        >
          <FormattedMessage id='btnBack' defaultMessage='Back' />
        </MyButton>,
        <MyButton
          isPrimary
          onClick={handleClickSave}
          style={{
            width: isDesktop ? '25%' : '30%',
          }}
        >
          <FormattedMessage id='btnSave' defaultMessage='Save' />
        </MyButton>,
      ]
      : isShowMap && !isDesktop
        ?
        <div style={{ marginTop: isDesktop ? `0px` : '-45px' }}>
          <MyButton
            isPrimary
            onClick={handleClickSave}
            style={{
              width: isDesktop ? '25%' : '100%',
              marginBottom: '-5px'
            }}
          >
            <FormattedMessage id='btnSave' defaultMessage='Save' />
          </MyButton>,
          <MyButton
            onClick={() => {
              setIsShowMap(false);
              setVisibleInfoWindow(false);
              setSelectAddress();
              setDragMarker('');
            }}
            style={{
              width: isDesktop ? '25%' : '100%',
              marginLeft: '0px',
            }}
          >
            <FormattedMessage id='btnBack' defaultMessage='Back' />
          </MyButton>,
          <MyButton
            onClick={handleCancle}
            style={{
              width: isDesktop ? '25%' : '100%',
              marginLeft: '0px',
            }}
          >
            <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
          </MyButton>,
        </div>

        : !isShowMap && isDesktop
          ? [
            <MyButton
              onClick={handleCancle}
              style={{
                width: isDesktop ? 'auto' : '48%',
              }}
            >
              <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
            </MyButton>,
            <MyButton
              isPrimary
              // loading={loading}
              onClick={handleClickSave}
              style={{
                width: isDesktop ? 'auto' : '48%',
              }}
            >
              <FormattedMessage id='btnNext' defaultMessage='Next' />
            </MyButton>,
          ]
          : [
            <MyButton
              isPrimary
              onClick={handleClickSave}
              style={{
                width: isDesktop ? 'auto' : '100%',
              }}
            >
              <FormattedMessage id='btnNext' defaultMessage='Next' />
            </MyButton>,
            <MyButton
              onClick={handleCancle}
              style={{
                width: isDesktop ? 'auto' : '100%',
                marginLeft: '0px',
                marginTop: '8px',
              }}
            >
              <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
            </MyButton>,
          ];

  // //console.log('center', visibleInfoWindow);

  const handleChange = debounce(async (values) => {
    const comCode = GetProfile('customerCode');
    const body = {
      where: values,
      page: 1,
      limit: 100,
    };
    try {
      const response = await instance.post(`/v3/business-partner/manager/company/${comCode}/location-informations/searchlocation`, body);
      setOptions(response.data.data.rows);
      setIsSelect(false);
    } catch (error) { }
  }, 1000);

  return (
    <Modal
      title={
        isEdit ? (
          <Typography color={COLORS.Primary} isBold size='16px' className={isDesktop ? 'pb-3' : 'text-center pb-2'}>
            <FormattedMessage id='modalEditAddress' defaultMessage='Edit Address' />
          </Typography>
        ) : (
          <Typography color={COLORS.Primary} isBold size='16px' className={isDesktop ? 'pb-3' : 'text-center pb-2'}>
            <FormattedMessage id='modaCreateAddress' defaultMessage='Create Address' />
          </Typography>
        )
      }
      maskClosable={false}
      open={isOpen}
      onOk={() => { }}
      onCancel={handleCancle}
      width={560}
      bodyStyle={{ height: isShowMap === true && !isDesktop ? '70%' : '80%', paddingBottom: isShowMap && !isDesktop ? '35px' : null }}
      centered={isDesktop ? true : false}
      footer={checkView}
    >
      <Divider className='m-0' />
      {isShowMap ? (
        <GoogleMap
          ref={mapRef}
          onUnmount={onUnmount}
          mapContainerStyle={mapContainerStyle}
          center={center}
          zoom={16}
          onLoad={onMapLoad}
          options={defaultMapOption}
        >
          <MarkerF
            position={position}
            animation={window.google.maps.Animation.DROP}
            onClick={() => onClickMarker()}
            draggable={true}
            onDragEnd={onDragEnd}
          >
            {visibleInfoWindow === true ? (
              <InfoWindowF position={position} onCloseClick={() => onCloseMarker()}>
                <div style={{ padding: '12px' }}>{_.get(selectAddress, 'address')}</div>
              </InfoWindowF>
            ) : null}
          </MarkerF>
        </GoogleMap>
      ) : (
        <CustomerAddressForm
          isEdit={isEdit}
          isSaveAddr={isSaveAddr}
          form={form}
          handleSearchLocation={handleSearchLocation}
          addressEditData={addressEditData}
          selectArea={selectArea}
          setSelectArea={setSelectArea}
          isOpen={isOpen}
          // isTemp={isTemp}
          setIsTemp={setIsTemp}
          isSelect={isSelect}
          setIsSelect={setIsSelect}
          handleChange={handleChange}
          options={options}
        />
      )}
    </Modal>
  );
};

export default CustomerAddressModal;
